import { Tooltip } from "react-tooltip";

import Category from "./Category";
import Option from "./Option";
import CategoryDataProvider from "./context/CategoryDataContext";
import days from "./json/days-validated.json";
import servents from "./json/servent-names-ids.json";

const Grid = (day) => {
    // console.log(day);
    const dayOffset = 730;

    const d = day.day;
    const gridDay = (d - dayOffset + 1) % days["grids"].length;
    // console.log(gridDay);
    const categoryData = days["grids"][gridDay];
    const validOptions = days["solutions"][gridDay];
    // console.log(days);

    return (
        <div>
            <CategoryDataProvider value={categoryData}>


                <div id='grid' className="grid">
                    <Category classType={"category border-top border-left"} data={categoryData[0]} day={d} /> { /*1*/}
                    <Category classType={"category border-top border-left"} data={categoryData[1]} /> { /*2*/}
                    <div className="play-grid">
                        <Option servents={servents} validOptions={validOptions[0]} opID={1} day={d} />
                        <Option servents={servents} validOptions={validOptions[1]} opID={2} day={d} />
                        <Option servents={servents} validOptions={validOptions[2]} opID={3} day={d} />
                        <Option servents={servents} validOptions={validOptions[3]} opID={4} day={d} />
                        <Option servents={servents} validOptions={validOptions[4]} opID={5} day={d} />
                        <Option servents={servents} validOptions={validOptions[5]} opID={6} day={d} />
                        <Option servents={servents} validOptions={validOptions[6]} opID={7} day={d} />
                        <Option servents={servents} validOptions={validOptions[7]} opID={8} day={d} />
                        <Option servents={servents} validOptions={validOptions[8]} opID={9} day={d} />
                    </div>
                    <Category classType={"category border-top border-left"} data={categoryData[2]} /> { /*3*/}
                    <Category classType={"category border-top border-left border-right"} data={categoryData[3]} /> { /*4*/}
                    <Category classType={"category border-top border-left"} data={categoryData[4]} /> { /*5*/}
                    <Category classType={"category border-top border-left"} data={categoryData[5]} /> { /*6*/}
                    <Category classType={"category border-top border-left border-bottom"} data={categoryData[6]} />  { /*7*/}
                </div>

                <Tooltip id="category-tooltip" classNameArrow="tooltip-arrow" />
            </CategoryDataProvider>
        </div>
    );
}

export default Grid;